import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "./themes/default-dark.scss";
import "./themes/default.scss";
import VueToastr from "@deveodk/vue-toastr";
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import moment from "moment";
import axios from "axios";
import VueNativeSock from "vue-native-websocket";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import VueBarcode from "@chenfengyuan/vue-barcode";
import MdDialogAlertBarcode from "./components/MdDialogAlertBarcode";
import MdDialogSystemBarcode from "./components/MdDialogSystemBarcode";
import Vue2TouchEvents from "vue2-touch-events";
import vueDebounce from 'vue-debounce';

Vue.use(vueDebounce)


Raven.config("https://616f2ed7b4ea4e8589035013cd389cdf@sentry.io/1376612")
  .addPlugin(RavenVue, Vue)
  .install();

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = false;

Vue.use(VueMaterial);
Vue.use(VueToastr, {
  defaultPosition: "toast-top-left",
  defaultTimeout: 3000,
});

Vue.use(Vue2TouchEvents, {
  longTapTimeInterval: 400,
});

const SOCKET_ONOPEN = "websocket/SOCKET_ONOPEN";
const SOCKET_ONCLOSE = "websocket/SOCKET_ONCLOSE";
const SOCKET_ONERROR = "websocket/SOCKET_ONERROR";
const SOCKET_ONMESSAGE = "websocket/SOCKET_ONMESSAGE";
const SOCKET_RECONNECT = "websocket/SOCKET_RECONNECT";
const SOCKET_RECONNECT_ERROR = "websocket/SOCKET_RECONNECT_ERROR";

const mutations = {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR,
};

Vue.use(VueNativeSock, process.env.VUE_APP_WS_ENDPOINT, {
  store: store,
  mutations: mutations,
  connectManually: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 3000,
});

Vue.prototype.$axios = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

Vue.component("barcode", VueBarcode);
Vue.component("md-dialog-alert-barcode", MdDialogAlertBarcode);
Vue.component("md-dialog-system-barcode", MdDialogSystemBarcode);

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY hh:mm");
  }
});

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
  watch: {
    auth: {
      handler: function () {
        if (this.auth.apiKey !== null) {
          this.$axios.defaults.headers["X-Auth-Token"] = this.auth.apiKey;
          this.$connect();
          this.$router.push({ name: "home" });
        } else {
          delete this.$axios.defaults.headers["X-Auth-Token"];
          this.$disconnect();
          this.$router.push({ name: "login" });
        }
      },
      deep: true,
    },
  },
  created: function () {
    this.$material.theming.themes = this.themes;

    if (this.auth.apiKey === null) {
      this.$router.push({ name: "login" });
      delete this.$axios.defaults.headers["X-Auth-Token"];
    } else {
      this.$axios.defaults.headers["X-Auth-Token"] = this.auth.apiKey;
      this.$connect();
    }

    this.$axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          this.$store.commit("messages/setMessage", {
            type: "error",
            code: "Ой все!",
            message: error.response.statusText,
          });
          store.commit("auth/unsetAuth");
          store.commit("product/unsetProduct");
        } else if (error.response.status === 422) {
          console.info("Validation errors", error.response.data);
        } else {
          console.info("some error");
          store.commit("messages/setMessage", {
            type: "error",
            code: error.response.status ? error.response.status : 500,
            message: error.response.data
              ? error.response.data[0] !== "<"
                ? error.response.statusText
                : error.response.statusText
              : "Invalid server error response format",
          });
        }

        return Promise.reject(error);
      }
    );
  },
  computed: {
    auth() {
      return store.state.auth.item;
    },
    theme() {
      return this.$store.state.themes.themes;
    },
  },
  methods: {
    logout: function () {
      store.commit("auth/unsetAuth");
      this.$router.push({ name: "login" });
    },
  },
}).$mount("#app");

router.beforeEach((to, from, next) => {
  const auth = app.$store.state.auth.item;
  app.$store.commit("product/unsetProduct");
  if (to.name !== "login") {
    if (auth.apiKey !== null) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
});
